export { Carousel } from "../overrides/carousel";

// Soon to be depricated.
import { Carousel } from "../overrides/carousel";
const carouselTrigger = el => {
  window.orbit.carouselInstance = new Carousel(el);
};

window.orbit = window.orbit || {};
window.orbit.carousel = carouselTrigger;
export default Carousel
